import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  RendererFactory2
} from '@angular/core';
import { NavigationEnd, Router, RouterStateSnapshot } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AnalyticService } from './shared/services/analytic.service';
import { CanonicalUrlService } from './shared/services/canonical-url.service';
import { MoreInfoService } from './shared/services/more-info.service';

@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
  public subscriptions = new Subscription();
  public url: string = '';
  title = 'test-angular-app';
  public env: string = '';
  private renderer: Renderer2;
  constructor(
    private router: Router,
    private analityc: AnalyticService,
    private canonical: CanonicalUrlService,
    rendererFactory: RendererFactory2,
    private moreInfoService: MoreInfoService
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    if (!this.moreInfoService.getMoreInfo().isShowedBackRedirection) {
      // This will trigger the browser's built-in confirmation dialog
      $event.preventDefault();
      $event.returnValue = ''; // Some browsers require this to show the dialog
    }
  }

  ngOnInit() {
    this.initListenNavigationEvents();
    const script = this.renderer.createElement('script');
    script.src = environment.assetsUrl + '/common/js/rsa.js';
    this.renderer.appendChild(document.body, script);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private initListenNavigationEvents(): void {
    this.subscriptions.add(
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          map(() => this.router.routerState.snapshot)
        )
        .subscribe((snapshot: RouterStateSnapshot) => {
          this.url = snapshot.url.split('?')[0];
          this.canonical.addCanonicalUrl(this.url);
          this.analityc.pageViewEvent(this.url);
        })
    );
  }
}
